
define('core/util',["require", "exports"], function(require, exports) {
    function roughSizeOfObject(object) {
        var bytes, key, objectList, prop, stack, value;
        objectList = [];
        stack = [object];
        bytes = 0;
        while (stack.length !== 0) {
            value = stack.pop();
            if (typeof value === 'boolean') {
                bytes += 4;
            } else if (typeof value === 'string') {
                bytes += value.length * 2;
            } else if (typeof value === 'number') {
                bytes += 8;
            } else if (typeof value === 'object' && objectList.indexOf(value) < 0) {
                objectList.push(value);
                bytes += 4;
                for (key in value) {
                    prop = value[key];
                    bytes += key.length * 2;
                    stack.push(prop);
                }
            }
        }
        return bytes;
    }
    exports.roughSizeOfObject = roughSizeOfObject;

    exports.isIE = (/(msie) ([\w.]+)/.exec(navigator.userAgent.toLowerCase()) != null || navigator.userAgent.indexOf('Trident') !== -1);
});
//# sourceMappingURL=util.js.map
;